import { useEffect, useState } from "react";

import {
  getMaintenanceMode,
  schedulePageRefresh,
  setMaintenanceModeStorage,
} from "./maintenance-mode-service.context.lib";

export const useMaintenanceModeComponent = () => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState<boolean>(false);
  const [refreshScheduled, setRefreshScheduled] = useState<boolean>(false);

  // Initialize from localStorage on mount
  useEffect(() => {
    const storedMode = getMaintenanceMode();
    setIsMaintenanceMode(storedMode);
  }, []);

  const handleSetMaintenanceMode = (value: boolean) => {
    setIsMaintenanceMode(value);
    setMaintenanceModeStorage(value);

    // Schedule refresh only when transitioning to maintenance mode
    if (value && !refreshScheduled) {
      schedulePageRefresh();
      setRefreshScheduled(true);
    } else if (!value) {
      setRefreshScheduled(false);
    }
  };

  return {
    isMaintenanceMode,
    setMaintenanceMode: handleSetMaintenanceMode,
    scheduleRefresh: () => schedulePageRefresh(),
  };
};
